import { useId } from "react";

export default function AssignmentFolderIcon() {
  const id = useId();
  return (
    <svg className="assignment-folder-icon" aria-hidden="true" viewBox="0 0 104 88" fill="none">
      <defs>
        <linearGradient id={`${id}-back`} x1="24" y1="12" x2="82" y2="72" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EBC57C" />
          <stop offset="1" stopColor="#BF8C40" />
        </linearGradient>
        <linearGradient id={`${id}-front`} x1="38" y1="35" x2="56" y2="78" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBE2AA" />
          <stop offset=".48" stopColor="#F0CB83" />
          <stop offset="1" stopColor="#DEB167" />
        </linearGradient>
        <linearGradient id={`${id}-paper`} x1="38" y1="22" x2="65" y2="59" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFFDF8" />
          <stop offset="1" stopColor="#EDE5D5" />
        </linearGradient>
        <radialGradient id={`${id}-shadow`}>
          <stop stopColor="#725329" stopOpacity=".23" />
          <stop offset="1" stopColor="#725329" stopOpacity="0" />
        </radialGradient>
      </defs>
      <ellipse cx="52" cy="80" rx="45" ry="7" fill={`url(#${id}-shadow)`} />
      <path
        d="M17 27V19a6 6 0 0 1 6-6h19l8 8h33a6 6 0 0 1 6 6v42l-7 7H17V27Z"
        fill={`url(#${id}-back)`}
        stroke="#B98B49"
      />
      <path d="m89 28 6 5-6 36-7 7 7-48Z" fill="#B78743" />
      <rect x="28" y="23" width="49" height="41" rx="3" transform="rotate(-7 28 23)" fill="#F6F0E4" stroke="#D6CBB5" />
      <rect x="23" y="27" width="57" height="39" rx="3" fill={`url(#${id}-paper)`} stroke="#D6CBB5" />
      <path d="M31 33h31M31 39h39M31 45h24" stroke="#D8CDB9" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M14 38h73a5 5 0 0 1 5 6l-7 26a8 8 0 0 1-8 6H18a6 6 0 0 1-6-5L9 44a5 5 0 0 1 5-6Z"
        fill={`url(#${id}-front)`}
        stroke="#C69B5A"
      />
      <path d="M14 40h72" stroke="#FFF0CC" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 72h58a5 5 0 0 0 5-4" stroke="#D2A25A" strokeOpacity=".6" strokeLinecap="round" />
      <rect x="24" y="53" width="24" height="10" rx="3" fill="#FFF5DD" fillOpacity=".65" />
      <path d="M30 58h12" stroke="#BD965D" strokeOpacity=".55" strokeLinecap="round" />
    </svg>
  );
}
